var M={SPACE:" ",COMMA:",",DOT:".",EMPTY:""};export{M as NUMBER_SEPARATORS};
//# sourceMappingURL=numberSeparators.js.map
